/* eslint-disable no-shadow */
export enum ValidationRules {
	REQUIRED = 'required',
	PATTERN = 'pattern',
	USER_NOT_FOUND = 'userNotFound',
	LOGIN_FAILED = 'loginFailed',
	EQUAL_VALUE = 'equalValue',
}
